export default "__VITE_ASSET__CU6WQa8d__"